// eslint-disable-next-line import/prefer-default-export
export const pluralize = (count: number, noun: string, suffix: string = 's') => `${noun}${count !== 1 ? suffix : ''}`;
